import {privateAxios, serviceAxios} from "./axios-instances.ts";
import {useUserServiceApi} from "./auth/auth-api.ts";
import {useNavigate} from "@tanstack/react-router";

export function axiosInterceptor() {
    const navigate = useNavigate();
    const { memorizedRefreshToken, setAccessToken } = useUserServiceApi();


    const requestInterceptor = privateAxios.interceptors.request.use(
        async (config) => {
            let accessToken;

            if(sessionStorage.getItem("accessToken")) {
                accessToken = sessionStorage.getItem("accessToken")
            } else {
                accessToken = await serviceAxios.put("/auth/refresh");
                setAccessToken(accessToken.data.accessToken);
                sessionStorage.setItem("accessToken", accessToken.data.accessToken);
            }

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`; // set in header
            }
            return config;
        },
        (error) => Promise.reject(error)
    )

    const responseInterceptor = privateAxios.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;
            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    //call memorized refreshToken response
                    const newAccessToken = await memorizedRefreshToken();

                    if (newAccessToken) {
                        setAccessToken(newAccessToken);
                        sessionStorage.setItem("accessToken", newAccessToken);
                        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                        return privateAxios(originalRequest);
                    }
                } catch (error) {
                    console.error("Session expired, please log in again.");
                    sessionStorage.removeItem("accessToken");
                    navigate({to: "/login"})
                }
            }
            return Promise.reject(error);
        }
    );

    //clean up function
    return () => {
        privateAxios.interceptors.request.eject(requestInterceptor);
        privateAxios.interceptors.response.eject(responseInterceptor);
    }
}